var render = function render(){var _vm=this,_c=_vm._self._c;return _c('external-list',{attrs:{"endpoint":"/api/v2/portals"},on:{"show":_vm.show},scopedSlots:_vm._u([{key:"default",fn:function({ row: portal }){return [_c('td',[_c('router-link',{attrs:{"to":_vm.getUrl(portal)}},[_vm._v("\n                "+_vm._s(portal.attributes.name)+"\n            ")])],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }